import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state= {
  arrListProvince: [],
  arrListDistrict: [],
  arrListCategoryChild: {},
  arrListCategoryChildChild: {},
  arrListPreview: [],
  listingJustCreated: null,
  valueRedirect: false
};
const getters = {
  arrListProvince(state){
    return state.arrListProvince
  },
  listingCreated: (state) => state.listingCreated,
  valueRedirect: (state) => state.valueRedirect
};

const actions = {
  [actionType.GET_LIST_PROVINCES]: async function({ commit }, params){
    return new Promise((resolve, reject) => {
      api.get('/areas/provinces', {
        params: {
          take: params.take,
          page: params.page,
        },
      }).then(result => {
        commit(mutationType.SET_LIST_PROVINCES, {
          data: result.data.data
        })
      })
    .catch(error => reject(error));
    });
  },
  [actionType.GET_LIST_DISTRICTS]: async function({ commit }, params){
    return new Promise((resolve, reject) => {
      api.get('/areas/amphures', {
        params: {
          take: params.take,
          page: params.page,
          province_id: params.province_id
        },
      }).then(result => {
        commit(mutationType.SET_LIST_DISTRICTS, {
          data: result.data.data
        })
      })
    .catch(error => reject(error));
    });
  },
  [actionType.GET_CATEGORY_CHILD_BY_ID]: async function({ commit }, idCategory){
    return new Promise((resolve, reject) => {
      api.get(`/categories/${typeof idCategory=="object"?idCategory.id:idCategory}`).then(result => {
        commit(typeof idCategory=="object"&&idCategory.type?mutationType.LIST_CATEGORY_CHILD_CHILD:mutationType.LIST_CATEGORY_CHILD, {
          data: result.data.data
        })
      })
    .catch(error => reject(error));
    });
  },
  [actionType.USER_ADD_LISTING]: async function({ commit }, params){
    try {
      var formData = new FormData();
      Object.keys(params.listingAttr.data).forEach((key, index) => {
        const splitID = key.split("_");
        
        if(splitID[0] == "radioValue" || splitID[0] == "selectValue" && !(splitID[1] == "4" || splitID[1] == "22" || splitID[1] == "33")){
          formData.append(`listing_attributes[${index}][attr_id]`, splitID[1]);
          formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data[key]);
        }
        if(splitID[0] == "checkboxValue" ){
          formData.append(`listing_attributes[${index}][attr_id]`, splitID[1]);
          formData.append(`listing_attributes[${index}][value]`, params.listingAttr.data[key]);
          // formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data[key]);
        }
        if(splitID[0] == "inputValue" && (splitID[1] == "3" || splitID[1] == "21" || splitID[1] == "32")){
          formData.append(`listing_attributes[${index}][attr_id]`, splitID[1]);
          formData.append(`listing_attributes[${index}][value]`, parseFloat(params.listingAttr.data[key].replace(/\,+/g,'')));
          if(splitID[1] == "21"){
            formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data.selectValue_22);
          }else if(splitID[1] == "32"){
            formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data.selectValue_33);
          }else  if(splitID[1] == "3"){
            formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data.selectValue_4);
          }
        }
        if(splitID[0] == "inputValue" && !(splitID[1] == "3" || splitID[1] == "21" || splitID[1] == "32")){
          formData.append(`listing_attributes[${index}][attr_id]`, splitID[1]);
          formData.append(`listing_attributes[${index}][value]`, parseFloat(params.listingAttr.data[key].replace(/\,+/g,'')));
        }
        if(splitID[0] == "selectValue" && (splitID[1] == "4" || splitID[1] == "22" || splitID[1] == "33")){
          formData.append(`listing_attributes[${index}][attr_id]`, splitID[1]);
          if(splitID[1] == "22"){
            formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data.selectValue_22);
            formData.append(`listing_attributes[${index}][value]`, parseFloat(params.listingAttr.data.inputValue_21.replace(/\,+/g,'')));
          }else if(splitID[1] == "33"){
            formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data.selectValue_33);
            formData.append(`listing_attributes[${index}][value]`, parseFloat(params.listingAttr.data.inputValue_32.replace(/\,+/g,'')));
          }else  if(splitID[1] == "4"){
            formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data.selectValue_4);
            formData.append(`listing_attributes[${index}][value]`, parseFloat(params.listingAttr.data.inputValue_3.replace(/\,+/g,'')));
          }
        }
      });
      for (var pair of formData.entries()) {
          console.log(pair[0]+ ', ' + pair[1]); 
      }
      if(params.listing_image && params.listing_image.length){
        params.listing_image.forEach(file =>{
          formData.append(`listing_image`, file.file);
        })
      }
      formData.append('lat', params.lat);
      formData.append('lng', params.lng);
      formData.append('formatted_address', params.formatted_address);
      formData.append('title', params.title);
      formData.append('description', params.description);
      formData.append('price', params.price);
      formData.append('listing_category_id', params.listing_category_id);
      formData.append('province_id', params.province_id);
      formData.append('district_id', params.district_id);
      formData.append('email', params.email);
      if(params.phone){
        formData.append('phone', params.phone);
      }
      if(params.line_id){
        formData.append('line_id', params.line_id);
      }
      formData.append('postal_code', params.postal_code);
      formData.append('country', params.country);
      formData.append('keywords', params.keywords);
      formData.append('package_detail_ids', params.package_detail_ids);
      formData.append('affiliate_dates_ids', params.affiliate_dates_ids);
      if(params.website != null){
        formData.append('website', params.website);
      }
      return new Promise((resolve, reject) => {
        api.post("/listings", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(result => {
          commit(mutationType.LISTING_JUST_CREATED, {
            data: result.data.data
          })
          resolve(true)
        })
      .catch(error => reject(error));
      });
    } catch (error) {
    }
  },
  [actionType.USER_UPDATE_LISTING]: async function({ commit }, params){
    try {
      var formData = new FormData();
      let editeImageName=[];
      Object.keys(params.listingAttr.data).forEach((key, index) => {
        const splitID = key.split("_");
        
        if(splitID[0] == "radioValue" || splitID[0] == "selectValue" && !(splitID[1] == "4" || splitID[1] == "22" || splitID[1] == "33")){
          formData.append(`listing_attributes[${index}][attr_id]`, splitID[1]);
          formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data[key]);
        }
        if(splitID[0] == "checkboxValue" ){
          formData.append(`listing_attributes[${index}][attr_id]`, splitID[1]);
          formData.append(`listing_attributes[${index}][value]`, params.listingAttr.data[key]);
          // formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data[key]);
        }
        if(splitID[0] == "inputValue" && (splitID[1] == "3" || splitID[1] == "21" || splitID[1] == "32")){
          formData.append(`listing_attributes[${index}][attr_id]`, splitID[1]);
          formData.append(`listing_attributes[${index}][value]`, parseFloat(params.listingAttr.data[key].replace(/\,+/g,'')));
          if(splitID[1] == "21"){
            formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data.selectValue_22);
          }else if(splitID[1] == "32"){
            formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data.selectValue_33);
          }else  if(splitID[1] == "3"){
            formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data.selectValue_4);
          }
        }
        if(splitID[0] == "inputValue" && !(splitID[1] == "3" || splitID[1] == "21" || splitID[1] == "32")){
          formData.append(`listing_attributes[${index}][attr_id]`, splitID[1]);
          formData.append(`listing_attributes[${index}][value]`, parseFloat(params.listingAttr.data[key].replace(/\,+/g,'')));
        }
        if(splitID[0] == "selectValue" && (splitID[1] == "4" || splitID[1] == "22" || splitID[1] == "33")){
          formData.append(`listing_attributes[${index}][attr_id]`, splitID[1]);
          if(splitID[1] == "22"){
            formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data.selectValue_22);
            formData.append(`listing_attributes[${index}][value]`, parseFloat(params.listingAttr.data.inputValue_21.replace(/\,+/g,'')));
          }else if(splitID[1] == "33"){
            formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data.selectValue_33);
            formData.append(`listing_attributes[${index}][value]`, parseFloat(params.listingAttr.data.inputValue_32.replace(/\,+/g,'')));
          }else  if(splitID[1] == "4"){
            formData.append(`listing_attributes[${index}][pre_values_id]`, params.listingAttr.data.selectValue_4);
            formData.append(`listing_attributes[${index}][value]`, parseFloat(params.listingAttr.data.inputValue_3.replace(/\,+/g,'')));
          }
        }
      });
      console.log("params",params.listingAttr.data)
      if(params.listing_image && params.listing_image.length){
        params.listing_image.forEach(file =>{
          formData.append(`listing_image`, file.file);
          if(file.file.edit){
            editeImageName.push(file.file.name);
          }
        })
      }
      if(editeImageName.length){
        formData.append('edited_images', editeImageName.toString());
      }
      formData.append('lat', params.lat);
      formData.append('lng', params.lng);
      formData.append('formatted_address', params.formatted_address);
      formData.append('title', params.title);
      formData.append('description', params.description);
      formData.append('price', params.price);
      formData.append('listing_category_id', params.listing_category_id);
      formData.append('province_id', params.province_id);
      formData.append('district_id', params.district_id);
      formData.append('email', params.email);
      if(params.phone){
        formData.append('phone', params.phone);
      }
      if(params.line_id){
        formData.append('line_id', params.line_id);
      }
      formData.append('postal_code', params.postal_code);
      formData.append('country', params.country);
      formData.append('keywords', params.keywords);
      formData.append('package_detail_ids', params.package_detail_ids);
      formData.append('affiliate_dates_ids', params.affiliate_dates_ids);
			if (params.website != null) {
				formData.append('website', params.website);
			}
      return new Promise((resolve, reject) => {
        api.put(`/listings/${params.id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(result => {
          commit(mutationType.LISTING_JUST_CREATED, {
            data: result.data.data
          })
          resolve(true)
        })
      .catch(error => reject(error));
      });
    } catch (error) {
    }
  },
  [actionType.GET_LISTING_PREVIEW]: async function({ commit }, idListing){
    return new Promise((resolve, reject) => {
      api.get(`/listings/${idListing}`).then(result => {
        commit(mutationType.LISTING_PREVIEW, {
          data: result.data.data
        })
        resolve(true)
      })
    .catch(error => reject(error));
    });
  },
  [actionType.USER_CONFIRM_LISTING]: async function({ commit }, idListing){
    return new Promise((resolve, reject) => {
      api.put(`/listings/active/${idListing}`).then(result => {
        resolve(result)
      })
    .catch(error => reject(error));
    });
  },
  [actionType.TRANSLATE_LISTING]: async function({ commit }, params){
    return new Promise((resolve, reject) => {
      api.post(`/listings/translate`,params).then(result => {
        resolve(result)
      })
    .catch(error => reject(error));
    });
  },
};

const mutations = {
  [mutationType.SET_LIST_PROVINCES]: function(state, data) {
    state.arrListProvince = JSON.parse(JSON.stringify(data.data))
  },
  [mutationType.SET_LIST_DISTRICTS]: function(state, data) {
    state.arrListDistrict = JSON.parse(JSON.stringify(data.data))
  },
  [mutationType.LIST_CATEGORY_CHILD]: function(state, data) {
    state.arrListCategoryChild = data.data
  },
  [mutationType.LIST_CATEGORY_CHILD_CHILD]: function(state, data) {
    state.arrListCategoryChildChild = data.data
    console.log("LIST_CATEGORY_CHILD_CHILD",state.arrListCategoryChildChild);
  },
  [mutationType.LISTING_PREVIEW]: function(state, data) {
    state.arrListPreview = data.data
  },
  [mutationType.LISTING_JUST_CREATED]: function(state, data) {
    state.listingJustCreated = data.data
  },
  [mutationType.VALUE_WHEN_REDIRECT_ADD_LISTING]: function(state, data){
    state.valueRedirect = data
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}